import Chart from 'react-apexcharts';
import React, { useEffect, useState } from 'react';
import axios from 'axios';

import BACKEND_URL from '../../../api';
import { useCountry } from '../../../context/CountryContext';
import countryCodeMap from '../../../countryCodes1.json';

const countryList = [
    ["United States of America", "US"],
    ["Germany", "DE"],
    ["China, Pepole's Republic", "CN"],
    ["Great Britain", "GB"],
    ["France", "FR"],
    ["Italy", "IT"],
    ["India", "IN"],
    ["Kuwait", "KW"],
    ["Philippines, The", "PH"]
];

const CardTwo = ({ year }) => {
    const { currency } = useCountry();
    const userid = sessionStorage.getItem('userid')

    const [donutOptions, setDonutOptions] = useState({
        chart: {
            id: "donut-chart",
            toolbar: {
                show: true,
            },
        },
        labels: ["United States of America", "Germany", "China, Pepole's Republic", "Great Britain", "France", "Italy", "India", "Kuwait", "Philippines, The"],
        title: {
            text: "Origin Wise Billing",
            align: "center",
        },
        colors: ["#4bc0c0", "#ff6384", "#36a2eb", "#ffcd56", "#9966ff"],
        legend: {
            position: "bottom",
            horizontalAlign: "center",
            fontSize: "14px",
            markers: {
                width: 12,
                height: 12,
                radius: 12,
            },
        },
        plotOptions: {
            pie: {
                donut: {
                    size: "55%",
                    labels: {
                        show: true,
                        name: {
                            show: true,
                            fontSize: "22px",
                            fontFamily: "Helvetica, Arial, sans-serif",
                            fontWeight: 600,
                        },
                        value: {
                            show: true,
                            fontSize: "16px",
                            fontFamily: "Helvetica, Arial, sans-serif",
                            color: "#333",
                            formatter: (val) => val + " " + currency,
                        },
                        total: {
                            show: true,
                            label: "Total Billing",
                            color: "#333",
                            formatter: (w) => w.globals.seriesTotals.reduce((a, b) => a + b, 0) + " " + currency,
                        },
                    },
                },
            },
        },
        dataLabels: {
            enabled: false,
        },
        responsive: [
            {
                breakpoint: 480,
                options: {
                    chart: {
                        width: 300,
                    },
                    legend: {
                        position: "bottom",
                    },
                },
            },
        ],
    });

    const [donutSeries, setDonutSeries] = useState([0, 0, 0, 0, 0, 0, 0, 0, 0]);

    useEffect(() => {
        axios.post(`${BACKEND_URL}/getWiseRevenue`, {
            userid: userid,
            thisYear: year
        }, {})
            .then((res) => {
                console.log("getWiseRevenue------------", res.data)

                const keysArray = Object.keys(res.data);
                const temp = keysArray.map(key => countryCodeMap[key]);
                const temp1 = keysArray.map(key => res.data[key]);

                setDonutOptions({ ...donutOptions, labels: temp })
                setDonutSeries(temp1);
            })
            .catch((err) => console.log(err))
    }, [year])

    return (
        <div style={{ margin: "10px", borderRadius: "12px", border: "1px solid #E5E7EB", backgroundColor: "white", padding: "50px 10px" }}>
            <div>
                <div id="chartFour" className="-ml-5">
                    <Chart options={donutOptions} series={donutSeries} type="donut" height={350} />
                </div>
            </div>
        </div>
    );
};

export default CardTwo;
